import { Layout } from '@/components/layout/Layout';
import { BannerSection } from '@/components/sections/BannerSection';
import { HeroSection } from '@/components/sections/HeroSection';
import { StockSection } from '@/components/sections/StockSection';
import { ServicesSection } from '@/components/sections/ServicesSection';
import { AboutSection } from '@/components/sections/AboutSection';
import { RecentlySoldSection } from '@/components/sections/RecentlySoldSection';
import { ContactSection } from '@/components/sections/ContactSection';

const Index = () => {
  return (
    <Layout>
      <BannerSection />
      <HeroSection />
      <StockSection />
      <ServicesSection />
      <AboutSection />
      <RecentlySoldSection />
      <ContactSection />
    </Layout>
  );
};

export default Index;
